/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n){const t=1/n;return{antialiasing:t,blur:0+t}}export{n as getAntialiasingControls};
